import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import TextFieldWrapper from '../components/TextFieldWrapper/TextFieldWrapper';


class ValidationForm extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            enableActionBtn: this.props.enableActionBtnByDefault
        };
    }

    componentDidMount() {
        const { inputs } = this.props;
        const initialState = inputs.reduce((all, input) => {
            all[input.name] = input.value;
            return all;
        }, {});
        this.setState(initialState);
    }

    onTextInputChange = (e) => {
        const inputName = e.target.name;
        const { inputs } = this.props;
        const curInput = _.find(inputs, { name: inputName });

        if (curInput && curInput.onChange) {
            curInput.onChange({ [inputName]: e.target.value });
        }

        let startValidation = false, ii;

        for (let index = 0; index < inputs.length; index++) {
            const curInputEl = inputs[index];
            if (curInputEl.name === inputName) {
                startValidation = true;
                ii = index;
                this.setState({
                    ...this.state,
                    enableActionBtn: true,
                    [curInputEl.name]: e.target.value
                }, () => {
                    this.validate(curInputEl.name);
                });
            }
            if (startValidation && index > ii && this.state[curInputEl.name]) {
                setTimeout(() => {
                    this.validate(curInputEl.name);
                });
            }
        }
    }

    onTextInputBlur = (inputName) => {
        this.validate(inputName);
    }

    validate = (inputName, okAction) => {
        let { inputs } = this.props;
        let canProceed = true;
        let newState = {};

        if (inputName) {
            inputs = [_.find(inputs, { name: inputName })];
        }

        for (let i = 0; i < inputs.length; i++) {
            const curInput = inputs[i];
            const rules = curInput.rules || [];
            for (let j = 0; j < rules.length; j++) {
                const validationErr = rules[j]({ ...this.state, [curInput.name]: this.getValue(curInput) });
                const validationWarn = curInput.maxLength ? this.validateLength({ target: { name: curInput.name } }) : null;

                newState[`${curInput.name}FieldError`] = validationErr;
                newState[`${curInput.name}FieldInfo`] = validationWarn;

                if (validationErr || validationWarn) {
                    canProceed = false;
                }
            }
        }
        this.setState(newState, () => {
            if (canProceed && okAction) {
                okAction(this.state);
                this.setState({ enableActionBtn: false });
            }
        });
    }

    validateLength = (e) => {
        const { inputs } = this.props;
        const value = this.state[e.target.name];
        const input = _.find(inputs, { name: e.target.name });
        let info = null;

        if (value.length > input.maxLength) {
            info = input.maxLengthMsg;
        } else {
            info = null;
        }

        this.setInfo(input, info);

        return info;
    }

    getError({ name }) {
        return this.state[`${name}FieldError`];
    }

    getInfo({ name }) {
        return this.state[`${name}FieldInfo`];
    }

    setInfo({ name }, info) {
        this.setState({ [`${name}FieldInfo`]: info });
    }

    getLength({ name }) {
        return this.state[`${name}Length`];
    }

    setLength({ name }, length) {
        this.setState({ [`${name}Length`]: length });
    }

    getValue({ name }) {
        return this.state[name];
    }

    render() {
        const { inputs, buttons, formClassName, btnsClassName, enableActionBtnAlways, buttonsWrapper } = this.props;
        const { enableActionBtn } = this.state;
        const okBtn = _.find(buttons, { key: 'ok' });

        const invalid = inputs.map((input) => {
            if (this.getError(input) || this.getInfo(input)) {
                return input;
            }
            return null;
        }).filter((input) => !!input).length > 0;

        const buttonsEl = buttons.map(button => {
            const isOkBtn = button.key === 'ok';
            return <button
                key={button.key}
                className={`${(isOkBtn && (invalid || !enableActionBtn) && !enableActionBtnAlways) ? 'disabled' : ''} ${button.className}`}
                onClick={isOkBtn ? this.validate.bind(this, null, button.action) : button.action}>
                {button.label || button.content}
            </button>;
        });

        return <div className={formClassName}>
            {inputs.map((input, index) => {
                const error = this.getError(input) || '';
                const info = this.getInfo(input) || '';
                const value = this.getValue(input) || '';

                return <TextFieldWrapper
                    key={input.name}
                    autoFocus={index === 0 && this.props.autoFocus}
                    {...input}
                    placeholder={input.placeholder || input.label}
                    id={input.name || input.id}
                    error={error || info}
                    value={value}
                    type={input.type || 'text'}
                    autoComplete={input.autoComplete}
                    maxLength={input.maxLength ? input.maxLength + 1 : null}
                    onLengthValidate={input.maxLength ? this.validateLength : undefined}
                    onChange={this.onTextInputChange}
                    onBlur={this.onTextInputBlur}
                    onEnter={input.applyOnEnter ? this.validate.bind(this, (input.runFullValidationOnEnter ? null : input.name), okBtn.action) : null} />;
            })}
            {buttonsWrapper ?
                React.createElement(buttonsWrapper, [], buttonsEl) :
                <div className={btnsClassName}>
                    {buttonsEl}
                </div>}
        </div>;
    }
}


ValidationForm.propTypes = {
    inputs: PropTypes.array.isRequired,
    buttons: PropTypes.array.isRequired,
    btnsClassName: PropTypes.string,
    formClassName: PropTypes.string,
    enableActionBtnByDefault: PropTypes.bool,
    enableActionBtnAlways: PropTypes.bool,
};

export default ValidationForm;
